export const PAGE_TYPE = Object.freeze({
  HOME_PAGE: "home-page",
  SECTION_PAGE: "section-page",
  BIG_STORY_SECTION_PAGE: "big-story-section-page",
  TAG_PAGE: "tag-page",
  AUTHOR_PAGE: "author-page",
  SEARCH_PAGE: "search-page",
  STORY_PAGE: "story-page",
  CATALOG_PAGE: "catalog-page",
  STORY_PUBLIC_PREVIEW_PAGE: "story-public-preview-page",
  STORY_PREVIEW: "story-preview",
  HOME_PREVIEW: "home-preview",
  STATIC_PAGE: "static-page",
  PLAN_SELECTION_PAGE: "plan-selection-page",
  INDEPENDENCE_DAY_MEMBERSHIP: "independence-day-membership",
  DASHBOARD_PAGE: "dashboard-page",
  UGC_FORM_PAGE: "ugc-form-page",
  SUBSCRIBE_PAGE: "Subscribe-Page",
  VISUAL_STORY: "visual-story",
});
export const TAG_PAGE_URL_PREFIX = "/topic/";

export const LOGOS = {
  thequint_logo: "https://images.thequint.com/thequint/2020-05/396d150f-b9e4-42a5-b9e1-6a701adb90d6/TQLogo_120x120.png",
  hindi_logo: "https://images.thequint.com/quint-hindi/2020-07/5e1b55c9-87e1-4097-813c-88b34f292e90/Group__1_2x.png",
  fit_logo: "https://images.thequint.com/thequint-fit/2020-07/6bfd09f0-f7b9-42bc-ab9b-45229bc41819/FitBigLogo_1_2x.png",
};
